<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" content-class="map-dialog">
    <v-card tile>
      <v-toolbar dense color="primary" dark flat :max-height="48">
        <v-toolbar-title>{{docId}} ({{kontragentiName}})</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p>hello</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'document',
  data () {
    return {
      dialog: false,
      docId: false,
      kontragentiName: '',
      address: '',
      isLoading: false
    }
  },
  mounted () {
  },
  methods: {
    async open (docId, kontragentiName, address) {
      this.docId = docId
      this.kontragentiName = kontragentiName
      this.address = address
      this.dialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
